<template>
    <div class="container user-management-container">
      <el-card shadow="hover">
        <template #header>
          <div class="card-header">
            <h2>إدارة المستخدمين</h2>
          </div>
        </template>
  
        <el-table :data="users" v-loading="loading" border style="width: 100%">
          <el-table-column prop="name" label="الاسم" />
          <el-table-column prop="email" label="البريد الإلكتروني" />
          <el-table-column prop="user_type" label="نوع المستخدم" />
          <el-table-column label="الإجراءات" width="180" align="center">
            <template #default="{ row }">
              <el-button size="small" type="warning" @click="openNotificationDialog(row)" plain>
                <el-icon><Promotion /></el-icon> إرسال إشعار
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        
        </el-card>
  
      <el-dialog v-model="isNotificationDialogVisible" title="إرسال إشعار خاص" width="40%">
        <div v-if="targetUser">
          <p><strong>إلى المستخدم:</strong> {{ targetUser.name }}</p>
          <el-form :model="notificationForm" ref="notificationFormRef" label-position="top">
            <el-form-item label="عنوان الإشعار" prop="title" :rules="{ required: true, message: 'العنوان مطلوب', trigger: 'blur' }">
              <el-input v-model="notificationForm.title" />
            </el-form-item>
            <el-form-item label="محتوى الرسالة" prop="body" :rules="{ required: true, message: 'المحتوى مطلوب', trigger: 'blur' }">
              <el-input v-model="notificationForm.body" type="textarea" :rows="4" />
            </el-form-item>
          </el-form>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="isNotificationDialogVisible = false">إلغاء</el-button>
            <el-button type="primary" @click="sendPersonalNotification" :loading="isSending">
              إرسال الآن
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import { ElMessage } from 'element-plus';
  import { Promotion } from '@element-plus/icons-vue';
  
  const api = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || 'https://cale.caledonian.ly/api',
  });
  
  api.interceptors.request.use(config => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  });
  
  export default {
    name: 'UserManagement',
    components: { Promotion },
    data() {
      return {
        api: api, // لجعل api متاحاً في الدوال
        users: [],
        loading: false,
  
        // ✨ 3. البيانات والدوال الجديدة ✨
        isNotificationDialogVisible: false,
        isSending: false,
        targetUser: null,
        notificationForm: {
          title: '',
          body: '',
        },
      };
    },
    created() {
      this.fetchUsers();
    },
    methods: {
      async fetchUsers() {
        this.loading = true;
        try {
          const response = await this.api.get('/users'); // يفترض وجود endpoint لجلب المستخدمين
          this.users = response.data.data;
        } catch (error) {
          ElMessage.error('فشل في جلب قائمة المستخدمين.');
        } finally {
          this.loading = false;
        }
      },
  
      // دالة لفتح نافذة الإشعار
      openNotificationDialog(user) {
        this.targetUser = user;
        this.notificationForm = { title: '', body: '' }; // إعادة تعيين النموذج
        this.$nextTick(() => {
          this.$refs.notificationFormRef?.resetFields();
        });
        this.isNotificationDialogVisible = true;
      },
  
      // دالة لإرسال الإشعار
      async sendPersonalNotification() {
        if (!this.$refs.notificationFormRef) return;
        await this.$refs.notificationFormRef.validate(async (valid) => {
          if (!valid) return;
  
          this.isSending = true;
          try {
            const payload = {
              user_id: this.targetUser.id,
              title: this.notificationForm.title,
              body: this.notificationForm.body,
            };
            // استدعاء الـ endpoint الذي قمنا ببنائه سابقاً
            const response = await this.api.post('/notifications/send-to-user', payload);
            ElMessage.success(response.data.message);
            this.isNotificationDialogVisible = false;
          } catch (error) {
            ElMessage.error(error.response?.data?.message || 'فشل إرسال الإشعار.');
          } finally {
            this.isSending = false;
          }
        });
      },
    },
  };
  </script>
  
  <style scoped>
  .user-management-container {
    padding: 20px;
  }
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  </style>